
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { findPreferredTranslation } from "@/utils/languagePriority";

@Component({
  name: "translation-tabs",
})
export default class TranslationTabsComponent extends Vue {
  @Prop({ default: () => [] }) translations: Array<any>;
  @Prop({ default: () => [] }) requiredFields: string[];
  @Prop({ default: () => ["name", "title", "text", "description"] })
  filledFields: string[];
  @Prop({ default: false }) gridLayout: boolean;
  @Prop({ default: false }) hidePanelHeader: boolean;
  @Prop({ default: false }) compact: boolean;

  activeIndex = 0;
  private activeLangCode = "";

  mounted() {
    this.activateFirstFilledTranslation();
  }

  @Watch("translations")
  onTranslationsChanged() {
    this.restoreActiveTranslation();
  }

  get activeTranslation(): any {
    const translations = this.translations || [];
    return translations[this.activeIndex] || translations[0];
  }

  get tabFillStates(): boolean[] {
    const fields = this.filledFields || [];
    return (this.translations || []).map((item) =>
      fields.some((field) => this.hasValue(item, field))
    );
  }

  setActiveIndex(index: number) {
    this.activeIndex = index;
    this.activeLangCode = this.getLangCode((this.translations || [])[index]);
  }

  isValid(): boolean {
    const fields = this.requiredFields || [];
    if (!fields.length) return true;

    const translations = this.translations || [];
    const invalidIndex = translations.findIndex((item) =>
      fields.some((field) => !this.hasValue(item, field))
    );
    if (invalidIndex === -1) return true;

    this.activeIndex = invalidIndex;
    const invalidTranslation = translations[invalidIndex];
    this.$notification.error(
      `Заполните перевод для языка ${this.getLangCode(invalidTranslation)}`
    );
    return false;
  }

  getLangCode(item: any): string {
    return (item && (item.langCode || item.LangCode)) || "";
  }

  private hasValue(item: any, field: string): boolean {
    const value = this.getFieldValue(item, field);
    if (typeof value === "string") return !!value.trim();
    return value !== null && value !== undefined;
  }

  private getFieldValue(item: any, field: string): any {
    if (!item) return undefined;
    if (Object.prototype.hasOwnProperty.call(item, field)) return item[field];
    const pascalField = field.charAt(0).toUpperCase() + field.slice(1);
    if (Object.prototype.hasOwnProperty.call(item, pascalField)) return item[pascalField];
    const camelField = field.charAt(0).toLowerCase() + field.slice(1);
    return item[camelField];
  }

  private activateFirstFilledTranslation() {
    const translations = this.translations || [];
    if (!translations.length) {
      this.activeIndex = 0;
      return;
    }

    const preferredTranslation = findPreferredTranslation(translations);
    const preferredIndex = translations.indexOf(preferredTranslation);
    if (preferredIndex !== -1) {
      this.activeIndex = preferredIndex;
      this.activeLangCode = this.getLangCode(translations[preferredIndex]);
      return;
    }

    if (this.activeIndex >= translations.length) {
      this.activeIndex = 0;
    }
    this.activeLangCode = this.getLangCode(translations[this.activeIndex]);
  }

  private restoreActiveTranslation() {
    const translations = this.translations || [];
    if (!translations.length) {
      this.activeIndex = 0;
      this.activeLangCode = "";
      return;
    }

    const activeIndex = translations.findIndex(
      (item) => this.getLangCode(item) === this.activeLangCode
    );
    if (activeIndex !== -1) {
      this.activeIndex = activeIndex;
      return;
    }

    this.activateFirstFilledTranslation();
  }

  private isTranslationFilled(item: any): boolean {
    const fields = this.filledFields || [];
    return fields.some((field) => this.hasValue(item, field));
  }
}
